export default (path, queryString) => {
  if (queryString.includes('gh_src=') && queryString.includes('gh_jid=')) {
    return path + queryString;
  }
  return path;
};
